<template>
  <div class="app-settings">
    <header-mobile-page v-if="$mq === 'mobile'"
                        :label="child.name" />

    <base-switch v-model="selectedAppType"
                 :options="appTypes"
                 class="type-switch" />

    <app-settings :app-type="appType"
                  :mode-id="child.default_mode_id"
                  :child-id="childId" />
  </div>
</template>

<script>
  import AppSettings from '@/components/Child/ChildAppSettings/AppSettings'
  import HeaderMobilePage from '@/components/Header/HeaderMobilePage'

  export default {
    components: {
      AppSettings,
      HeaderMobilePage
    },

    props: {
      childId: {
        type: String,
        required: true
      }
    },

    data() {
      return {
        appType: '',
        selectedAppType: null,
        appTypes: [
          { key: 'android', value: 'Android' },
          { key: 'ios', value: 'iOS' }
        ]
      }
    },

    created() {
      this.selectedAppType = this.appTypes[0]
    },

    computed: {
      child() {
        return this.getChildById(this.childId)
      },

      ...mapGetters('children', {
        getChildById: 'getById'
      })
    },

    watch: {
      selectedAppType(item) {
        this.appType = item.key
      }
    },
  }
</script>

<style lang="scss" scoped>
  .app-settings {
    width: 100%;
    height: auto;

    padding: 0 20px 10px 20px;

    .type-switch {
      margin-bottom: 20px;
    }
  }
</style>